module.exports = __webpack_public_path__ + "static/media/logo-riopoty.9a91f026.png";